"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/util/inDOM.js
// module id = 143
// module chunks = 0